export default __webpack_public_path__ + "static/media/responsiveroadmap.0aecc1df.png";